// @ts-check
import React, { createContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { APP_FILTERS_MENU_ROUTES } from "../routers/routes/appFiltersMenuRoutes.router"
import { defineRoute } from "../utils/menu.utils"

/** @typedef {import("./SidebarContext.types.d.ts").context} context */

// @ts-ignore
// no default value as this will never be empty.
export const SideBarContextValues = createContext(
  /** @type {context} */
  ({})
)

export default function SidebarContext({ children }) {
  const location = useLocation()
  const [keyPath, setKeyPath] = useState(
    /** @type {context["keyPath"]} */
    ("")
  )

  // TODO: bug: keypath is changing a lot when doing nothing,
  // it can be seen with a console log:
  // console.log(keyPath)

  const [screenTitle, setScreenTitle] = useState(
    /** @type {context["screenTitle"]} */
    ("")
  )
  const [sidebarActive, setSidebarActive] = useState(false)

  useEffect(() => {
    const { pathToUse } = defineRoute(location.pathname)
    if (location.pathname === "/") return
    if (pathToUse !== keyPath && APP_FILTERS_MENU_ROUTES[pathToUse]) {
      console.log("Ruta: ", pathToUse)
      setKeyPath(pathToUse || "")
    }
  }, [location.pathname])

  return (
    <SideBarContextValues.Provider
      value={{
        keyPath,
        setKeyPath,
        screenTitle,
        setScreenTitle,
        sidebarActive,
        setSidebarActive,
      }}
    >
      {children}
    </SideBarContextValues.Provider>
  )
}
